/* polish.js — small quality-of-life and motion helpers. No dependencies, no layout changes.
   Safe by design: if this file never loads, the site looks and works exactly as before. */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var body = doc.body;
  if (!body) return;

  var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduced = !!(reduceQuery && reduceQuery.matches);
  var inEditor = !!(window.Shopify && window.Shopify.designMode);
  var motion = body.classList.contains('cs-motion') && !reduced && !inEditor;

  /* 1. Sticky header: measure it (so #anchors and focus never hide under it) and add a soft shadow on scroll */
  var header = doc.querySelector('.cs-header--sticky');
  if (header) {
    var measure = function () { root.style.setProperty('--cs-header-h', header.offsetHeight + 'px'); };
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
        ticking = false;
      });
    };
    measure();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
  }

  /* 2. Header menus: Escape or a click outside closes them (Escape returns focus to the menu button) */
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = doc.querySelectorAll('.cs-header details[open]');
    if (!open.length) return;
    var summary = open[0].querySelector('summary');
    for (var i = 0; i < open.length; i++) open[i].removeAttribute('open');
    if (summary) summary.focus();
  });
  doc.addEventListener('click', function (e) {
    var open = doc.querySelectorAll('.cs-header details[open]');
    for (var i = 0; i < open.length; i++) {
      if (!open[i].contains(e.target)) open[i].removeAttribute('open');
    }
  });

  /* 3. Add to cart: loading state + no accidental double submits */
  function resetForm(form) {
    delete form.dataset.csBusy;
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
  }
  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.dataset.csBusy) { e.preventDefault(); return; }
    form.dataset.csBusy = '1';
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    window.setTimeout(function () { resetForm(form); }, 10000);
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var forms = doc.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) resetForm(forms[i]);
  });

  if (!motion) return;

  /* 4. Images that are still loading fade in instead of popping in (the hover-swap image is left alone) */
  var imgs = doc.querySelectorAll('img[loading="lazy"]');
  for (var k = 0; k < imgs.length; k++) {
    var img = imgs[k];
    if (img.complete || img.matches('.cs-card__media img + img')) continue;
    img.classList.add('cs-fade');
    var show = (function (el) { return function () { el.classList.add('is-loaded'); }; })(img);
    img.addEventListener('load', show, { once: true });
    img.addEventListener('error', show, { once: true });
  }

  /* 5. Gentle reveal for content below the fold. Anything already on screen is never touched. */
  if (!('IntersectionObserver' in window)) return;
  var SELECTOR = [
    '.cs-section .cs-title', '.cs-row__list > li', '.cs-tiles__list > li', '.cs-benefits__list > li',
    '.cs-benefits__note', '.cs-bento__item', '.cs-faq__item', '.cs-quote__inner', '.cs-posts > li'
  ].join(',');
  var viewport = window.innerHeight || root.clientHeight;
  var nodes = doc.querySelectorAll(SELECTOR);
  var targets = [];
  for (var n = 0; n < nodes.length; n++) {
    var r = nodes[n].getBoundingClientRect();
    if (r.height > 0 && r.top > viewport * 0.92) targets.push(nodes[n]);
  }
  if (!targets.length) return;

  function finish(el) {
    el.removeAttribute('data-reveal');
    el.classList.remove('is-revealed');
    el.style.transitionDelay = '';
  }
  function reveal(el, delay) {
    el.style.transitionDelay = delay + 'ms';
    el.classList.add('is-revealed');
    var timer = window.setTimeout(done, 1500 + delay);
    function onEnd(ev) { if (ev.target === el && ev.propertyName === 'opacity') done(); }
    function done() {
      window.clearTimeout(timer);
      el.removeEventListener('transitionend', onEnd);
      finish(el);
    }
    el.addEventListener('transitionend', onEnd);
  }

  var io = new IntersectionObserver(function (entries, obs) {
    var batch = [];
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) batch.push(entries[i].target);
      else if (entries[i].boundingClientRect.top < 0) { obs.unobserve(entries[i].target); finish(entries[i].target); } /* jumped past it: just show it */
    }
    for (var j = 0; j < batch.length; j++) {
      obs.unobserve(batch[j]);
      reveal(batch[j], Math.min(j, 5) * 70);
    }
  }, { rootMargin: '0px', threshold: 0.01 });

  for (var t = 0; t < targets.length; t++) {
    targets[t].setAttribute('data-reveal', '');
    io.observe(targets[t]);
  }
  window.addEventListener('beforeprint', function () {
    for (var p = 0; p < targets.length; p++) finish(targets[p]);
  });
})();
